var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Breadcrumbs',{attrs:{"main":"Hotlist Card","title":"Hotlist Card"}}),_c('comingSoon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }